module.exports = __webpack_public_path__ + "static/img/state8.ced4aaad.png";